import React, { useMemo } from 'react'

//* HOCs
import { withUIContext } from 'context'

//* Components
import { Login, SignUp, ForgotPassword, ResetPassword } from "components/pages"

//* Style
import PopupStyle from './style'

const Popup = ({ closePopup, popupIsOpen, popupComponent, ...props }) => {

    const components = useMemo(() => ({
        login: Login,
        'sign-up': SignUp,
        'forgot-password': ForgotPassword,
        'reset-password': ResetPassword,
    }), [])

    const Child = useMemo(() => typeof popupComponent === 'string' && components[popupComponent] && components[popupComponent], [popupComponent])

    const clickHandler = (e) => {
        if (typeof e.target.className == 'string' && e.target.className.includes('parent-cont')) {
            closePopup()
        }
    }

    return popupIsOpen ? (
        <PopupStyle
            onClick={clickHandler}
            className={`parent-cont flexBoxColumn alignCenter alignMiddle ${props.className ? props.className : ''}`}>
            {props.children}
            {typeof popupComponent === 'string' ? <Child /> : popupComponent}
        </PopupStyle>) : ""
}

export default withUIContext(Popup, ['closePopup', 'popupIsOpen', 'popupComponent'])
